import immutable from "object-path-immutable"
import isequal from "lodash.isequal"
import { applyReducerHash } from "../../redux_helpers"
import type { RipplesApiResult, Action } from "../../state_types"

const standardizeFilters = (filters) => {
  const f = filters || {}

  return {
    page: (f.page && f.page.toString()) || "1",
    organisation: f.organisation || null,
    searchTerm: f.searchTerm || null,
    order: f.order || "name",
    group: f.group || null
  }
}

const reducers = {
  ARCHIVED_RIPPLES: (
    state: RipplesApiResult | null | undefined,
    action: Action
  ) => {
    const filters = action.query || action.meta.query || {}

    return immutable.set(state, ["filters"], standardizeFilters(filters))
  },
  RECEIVED_ARCHIVED_RIPPLE_LIST: (
    state: RipplesApiResult | null | undefined,
    action: Action
  ) => {
    const dataFilters = standardizeFilters(action.payload.filters)
    const stateFilters = standardizeFilters(state && state.filters)

    // Don't update unless the filters for the data returned matches
    // what the current filters (in state)
    if (isequal(dataFilters, stateFilters)) {
      return action.payload
    }

    return state
  },
  RIPPLE_RESTORED: () => {
    return {}
  }
}

export default function archivedRipplesReducer(
  state: RipplesApiResult = null,
  action: Action
): RipplesApiResult | null | undefined {
  return applyReducerHash(reducers, state, action)
}
